import { createFileRoute } from "@tanstack/react-router";
import CmsPage from "@/pages/CmsPage";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/$")({
  head: () =>
    buildSeoHead(
      {
        ...publicPageSeo.home,
        key: "404",
        path: "/404",
        title: "Sidan kunde inte hittas | Cloud Redovisning",
        description:
          "Sidan du söker finns inte längre. Gå vidare till våra tjänster inom bokföring, lön, bokslut och rådgivning.",
      },
      [],
      { noindex: true },
    ),
  component: CmsPage,
});
